import * as React from 'react';

import {
  Input,
} from '../../../../Shared/index';
import * as api from '../../modules/call_api';
import useModalAccessibility from '../../../../Shared/hooks/useModalAccessibility';
import DemoGuardedButton from '../../shared/demoGuardedButton';

const RenameModal = ({ onSuccess, closeModal, unitId, unitName, notice = null, }) => {
  // deliberately window.close (a no-op): click-outside must not discard a half-typed name
  const { modalRef } = useModalAccessibility(close);

  const [name, setName] = React.useState(unitName)
  const [errors, setErrors] = React.useState({})
  const [timesSubmitted, setTimesSubmitted] = React.useState(0)

  function handleNameChange(event) {
    setName(event.target.value)
  }

  function handleNameClear() {
    setName('')
  }

  function renameActivityPack() {
    api.changeActivityPackName(
      unitId,
      name,
      () => onSuccess('Activity pack renamed'),
      (response) => {
        setErrors(response.errors)
        setTimesSubmitted(timesSubmitted + 1)
      }
    )
  }

  let saveButtonClass = 'quill-button contained medium green focus-on-light';
  if (!name.length || unitName === name) {
    saveButtonClass += ' disabled';
  }

  return (
    <div className="modal-container rename-activity-pack-modal-container">
      <div className="modal-background" />
      <div
        aria-labelledby="renameActivityPackModalTitle"
        aria-modal="true"
        className="rename-activity-pack-modal quill-modal modal-body"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <div>
          <h3 className="title" id="renameActivityPackModalTitle">Rename your activity pack</h3>
        </div>
        {notice}
        <Input
          className="bordered large name"
          error={errors.name}
          handleCancel={handleNameClear}
          handleChange={handleNameChange}
          id="activity-pack-name-edit"
          label="Activity pack name"
          timesSubmitted={timesSubmitted}
          type="text"
          value={name}
        />
        <div className="form-buttons">
          <button className="quill-button outlined medium green focus-on-light" onClick={closeModal} type="button">Cancel</button>
          <DemoGuardedButton className={saveButtonClass} onClick={renameActivityPack}>Save</DemoGuardedButton>
        </div>
      </div>
    </div>
  )
}

export default RenameModal
